module.exports = __webpack_public_path__ + "static/media/07fbe638-d411-9339-1ba7-3d6a4151e125.73f0c13b.jpg";